import { NotifyCard, NotifyOverlay, notifyBtn } from "../../components/NotifyCard";

const hx = (a) => `0x${a.toString(16).toUpperCase()}`;

export const ChecksumWarnDialog = ({ open, addr, invalid, canFix, onFix, onWriteAnyway, onClose }) => {
  if (!open) return null;
  const list = invalid?.length ? invalid : (addr != null ? [{ name: "Checksum", addr }] : []);
  return (
    <NotifyOverlay testid="checksum-warn-overlay" onClose={onClose}>
      <NotifyCard type="warning" testid="checksum-warn-dialog" title="FILE BELUM CHECKSUM"
        message={`${list.length} checksum INVALID. Flash file ini bisa membuat ECU tidak hidup.${canFix ? " Klik OK — checksum diperbaiki otomatis sebelum WRITE." : " Perbaiki checksum file di Map Editor dulu."}`}
        actions={<>
          {(onWriteAnyway || !canFix) && <button data-testid="checksum-warn-cancel" onClick={onClose} className={notifyBtn.ghost}>{onWriteAnyway ? "BATAL" : "OK"}</button>}
          {onWriteAnyway && !canFix && <button data-testid="checksum-warn-write-anyway" onClick={onWriteAnyway} className={notifyBtn.danger}>TETAP WRITE</button>}
          {canFix && <button data-testid="checksum-warn-fix" onClick={onFix} className={notifyBtn.ok}>OK — FIX CHECKSUM</button>}
        </>}>
        <ul data-testid="checksum-warn-list" className="mt-3 space-y-1 rounded-lg border border-amber-500/20 bg-black/30 p-3 font-mono text-[13px]">
          {list.map((c, i) => (
            <li key={`${c.name}-${i}`} data-testid={`checksum-warn-item-${i}`} className="flex justify-between gap-3">
              <span className="text-slate-300">{c.name}</span>
              <span className="font-bold text-amber-300">INVALID @{hx(c.addr)}</span>
            </li>
          ))}
        </ul>
      </NotifyCard>
    </NotifyOverlay>
  );
};
